//// Accordian
(function($, window, undefined) {

  var defaults = {}
  
  function wbskColWidget(element, settings) {
    this.element = $(element)
    //this.id = `wbskcolwidget${(Math.random() * 9000000000000).toFixed(0)}`
    this.collection = this.element.attr('data-wbsk-collection-widget')
    this.settings = $.extend({}, defaults, settings)
    this.render()
  }

  wbskColWidget.prototype = {
   
    render:function(){
      var _this = this;
      fetch(`/collections/${_this.collection}?view=widget`).then(function(result){
        return result.text();
      }).then(function(html){
        _this.element.html(html)
        //_this.element.attr('id',_this.id)
        //$(`#${_this.id}`)
        _this.swiper = _this.element.find('.swiper-container').wbskSwiper({
          centeredSlides:false,
          loop:true,
          spaceBetween:20,
          slidesPerView:3,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1024:{
              slidesPerView: 2,
            },
            767: {
                slidesPerView: 2,
              },
            480: {
              slidesPerView: 1,
            }
          }
        });
      }).catch(function(error){
        console.log('widget error')
        console.log(error)
      })
    },
    
  
  }

  $.fn.wbskColWidget = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskColWidget', new wbskColWidget(this, settings))
    })
  }

}(jQuery, window));

